import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Phone, Shield } from "lucide-react";
import { Button } from "@/components/ui/button";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: "Home", path: "/" },
    { name: "Services", path: "/services" },
    { name: "About", path: "/about" },
    { name: "Service Areas", path: "/service-areas" },
    { name: "Gallery", path: "/gallery" },
    { name: "Contact", path: "/contact" },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="bg-primary text-primary-foreground sticky top-0 z-50" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2" data-testid="logo-link">
            <Shield className="h-8 w-8 text-accent" />
            <div className="flex flex-col">
              <span className="font-heading font-bold text-lg leading-tight">CRITTER WHISPERER CHARLIE</span>
              <span className="text-xs text-primary-foreground/70">Patrick Enterprises Canada</span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-6">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`font-heading text-sm uppercase tracking-wide transition-colors hover:text-accent ${
                  isActive(link.path) ? "text-accent" : ""
                }`}
                data-testid={`nav-link-${link.name.toLowerCase().replace(" ", "-")}`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          {/* Emergency Call Button */}
          <div className="hidden md:flex items-center gap-4">
            <a
              href="tel:343-263-2000"
              className="flex items-center gap-2 bg-accent text-accent-foreground px-4 py-2 rounded-sm font-heading text-sm uppercase tracking-wide rugged-shadow transition-all hover:bg-accent/90"
              data-testid="emergency-call-btn"
            >
              <Phone className="h-4 w-4" />
              343-263-2000
            </a>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden p-2"
            data-testid="mobile-menu-btn"
          >
            {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="md:hidden pb-4" data-testid="mobile-menu">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`block py-2 font-heading text-sm uppercase tracking-wide ${
                  isActive(link.path) ? "text-accent" : ""
                }`}
                onClick={() => setIsOpen(false)}
                data-testid={`mobile-nav-link-${link.name.toLowerCase().replace(" ", "-")}`}
              >
                {link.name}
              </Link>
            ))}
            <a
              href="tel:343-263-2000"
              className="flex items-center gap-2 mt-4 bg-accent text-accent-foreground px-4 py-2 rounded-sm font-heading text-sm uppercase tracking-wide w-fit"
              data-testid="mobile-emergency-call-btn"
            >
              <Phone className="h-4 w-4" />
              343-263-2000
            </a>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
